import classNames from 'classnames';
import React from 'react';

import {INDENT_SIZE} from 'notebook/notes/lists/ListConstants';
import {NOTE_PADDING} from 'notebook/notes/NoteConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

interface SelectableNotePartProps {
  className?: string;
  indentation: number;
  children: React.ReactNode;
  blockDragAndDropReason?: string;
}

/**
 * A wrapper component for note parts that can be selected.
 */
export default function SelectableNotePart(props: SelectableNotePartProps): JSX.Element {
  const indentationPx = NOTE_PADDING + props.indentation * INDENT_SIZE;
  return (
    <div
      className={classNames('selectableNotePart', props.className)}
      data-mediocre-item-select={1}
      data-mediocre-item-block-dnd={props.blockDragAndDropReason}
      style={{
        paddingTop: NOTE_PADDING,
        paddingRight: NOTE_PADDING,
        paddingBottom: NOTE_PADDING,
        paddingLeft: indentationPx,
      }}
      {...getTestProps({component: 'SelectableNotePart', element: 'root'})}
    >
      {props.children}
    </div>
  );
}
